export const environment = {
  production: true,
         API_URL:"https://repse.apps-latam.com/supplier-app/public/api/auth"
        //  https://repse.apps-latam.com/ppse/supplier-front/login
        // API_URL:"http://10.14.105.171/supplier-app/public/api/auth"
  
};
